export { default } from './ConfettiBackgroundSquare';
export * from './ConfettiBackgroundSquare';
